import { Box, FormControl, MenuItem, Select, SelectChangeEvent, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { ProductMerchantModel } from '../../../models/productMerchant'
import { EN_ACCEPT_LANGUAGE } from '../../../constants/acceptLanguageApi'
import { numberFormat } from '../../../utils/nunberFormat'

interface Props {
    productData: ProductMerchantModel[]
    value: number
    onSelectedProduct: (event: SelectChangeEvent<any>) => void;
}

const SelectProductComponents = ({ productData, value, onSelectedProduct }: Props) => {
    const { t, i18n } = useTranslation('global')

    return (
        <>
            {
                productData?.length === 0 ?
                    <Box sx={{ mb: 1 }}>
                        {/* <Typography color='error'>{controller.errorMessageX}</Typography> */}
                    </Box> : <Box>
                        <Typography>{t("promotion_page.Select product")}</Typography>
                        <FormControl fullWidth margin="normal" size='small'>
                            <Select
                                value={value}
                                onChange={onSelectedProduct}
                            >
                                {
                                    productData?.map((product: ProductMerchantModel) => (
                                        <MenuItem
                                            key={product.id}
                                            // value={product.price?.masterProduct?.id}
                                            value={product?.price?.quantity}
                                        >
                                            {i18n.language === EN_ACCEPT_LANGUAGE ? product?.price?.masterProduct?.productNameEn : product?.price?.masterProduct?.productNameLa}
                                            &nbsp;&nbsp;
                                            <span style={{ color: 'red' }}>{product?.price?.masterProduct?.packType}</span>
                                            &nbsp;
                                            (&nbsp;<span>{t("promotion_page.Barcode")} : <span style={{ color: 'red' }}>{product?.price?.masterProduct?.barcodes[0]}</span></span>&nbsp;)
                                            &nbsp;
                                            <span>{t("Price")}&nbsp;:&nbsp;{numberFormat(product?.price?.price)}&nbsp;{t("Kip")}</span>
                                        </MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                    </Box>
            }
        </>
    )
}

export default SelectProductComponents